import React from 'react';
import { Box, HStack, VStack, Text, Icon } from '@chakra-ui/react';
import { FiMail, FiUser } from 'react-icons/fi';
import { LuWallet, LuMessageCircleQuestion } from 'react-icons/lu';
import { HiOutlineOfficeBuilding } from 'react-icons/hi';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';

interface MobileTabBarProps {}

interface TabItemProps {
    icon: any;
    label: string;
    isActive: boolean;
    onClick: () => void;
}

const TabItem: React.FC<TabItemProps> = ({ icon, label, isActive, onClick }) => {
    return (
        <VStack
            as="button"
            gap={1}
            px={1}
            py={2}
            flex={1}
            cursor="pointer"
            onClick={onClick}
            _active={{
                transform: 'scale(0.95)',
            }}
            transition="all 0.2s ease-in-out"
        >
            <Icon
                as={icon}
                boxSize={6}
                color={isActive ? 'yellow.600' : 'gray.500'}
                transition="color 0.2s"
            />
            <Text
                fontSize="sm"
                fontWeight={isActive ? 'semibold' : 'medium'}
                color={isActive ? 'yellow.600' : 'gray.500'}
                transition="all 0.2s"
                textAlign="center"
            >
                {label}
            </Text>
        </VStack>
    );
};

const MobileTabBar: React.FC<MobileTabBarProps> = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const tabItems = [
        { icon: FiMail, label: t.sidebar.menu.mail, path: '/mail' },
        { icon: HiOutlineOfficeBuilding, label: t.sidebar.menu.office, path: '/office' },
        { icon: LuWallet, label: t.sidebar.menu.payment, path: '/payment' },
        { icon: LuMessageCircleQuestion, label: t.sidebar.menu.support, path: '/support' },
        { icon: FiUser, label: t.sidebar.menu.profile, path: '/profile' },
    ];

    return (
        <Box
            position="fixed"
            bottom={0}
            left={0}
            right={0}
            bg="white"
            borderTop="1px solid"
            borderColor="gray.200"
            boxShadow="0 -4px 20px rgba(0, 0, 0, 0.1)"
            zIndex={1000}
            pb="env(safe-area-inset-bottom)"
        >
            <HStack gap={0} p={2} pb={4}>
                {tabItems.map((item) => (
                    <TabItem
                        key={item.path}
                        icon={item.icon}
                        label={item.label}
                        isActive={
                            location.pathname === item.path || location.pathname.startsWith(item.path + '/')
                        }
                        onClick={() => navigate(item.path)}
                    />
                ))}
            </HStack>
        </Box>
    );
};

export default MobileTabBar;
